import http from './http';

export type AdminUserSummary = {
  id: string; email: string; name: string | null;
  is_active: boolean; is_owner: boolean;
  role: string | null;
  created_at: string; last_login_at: string | null;
  workspace_count: number;
};

export type AdminUserDetail = AdminUserSummary & {
  updated_at: string | null;
  workspaces: { id: string; name: string; role: string; is_creator: boolean }[];
};

export type AdminStats = {
  total_users: number; active_users: number;
  new_users_7d: number; new_users_30d: number;
  total_workspaces: number;
};

export type AdminListResponse = {
  users: AdminUserSummary[]; total: number; page: number; per_page: number;
};

const BASE = '/admin';

export const adminApi = {
  getStats: () => http.get<AdminStats>(`${BASE}/stats`).then(r => r.data),
  listUsers: (params: { page?: number; per_page?: number; search?: string }) =>
    http.get<AdminListResponse>(`${BASE}/users`, { params }).then(r => r.data),
  getUser: (id: string) => http.get<AdminUserDetail>(`${BASE}/users/${id}`).then(r => r.data),
  resetPassword: (id: string, new_password: string) =>
    http.put(`${BASE}/users/${id}/password`, { new_password }).then(r => r.data),
  updateEmail: (id: string, email: string) =>
    http.put(`${BASE}/users/${id}/email`, { email }).then(r => r.data),
  updateName: (id: string, name: string) =>
    http.put(`${BASE}/users/${id}/name`, { name }).then(r => r.data),
  updateStatus: (id: string, is_active: boolean) =>
    http.put(`${BASE}/users/${id}/status`, { is_active }).then(r => r.data),
  deleteUser: (id: string, hard = false) =>
    http.delete(`${BASE}/users/${id}`, { params: { hard } }).then(r => r.data),
  createUser: (b: { email: string; name: string; password: string; is_active?: boolean }) =>
    http.post<AdminUserSummary>(`${BASE}/users`, b).then(r => r.data),
  userWorkspaces: (id: string) =>
    http.get(`${BASE}/users/${id}/workspaces`).then(r => r.data),
  updateRole: (userId: string, workspaceId: string, role: string) =>
    http.put(`${BASE}/users/${userId}/workspaces/${workspaceId}/role`, { role }).then(r => r.data),
};